import { FC, PropsWithChildren } from 'react';

import Box from '../Box';

// Local Typings
export type ContainerPosition = 'bottom' | 'left' | 'right' | 'top';
interface Props {
  isFullScreen: boolean | undefined;
  isOpen: boolean;
  isPaddingDisabled: boolean | undefined;
  position: ContainerPosition;
  transition: number;
}

// Local Variables
function getTransform(props: Props) {
  switch (props.position) {
    case 'bottom':
      return props.isOpen ? 'translateY(0%)' : 'translateY(100%)';
    case 'left':
      return props.isOpen ? 'translateX(0%)' : 'translateX(-100%)';
    case 'right':
      return props.isOpen ? 'translateX(0%)' : 'translateX(100%)';
    case 'top':
      return props.isOpen ? 'translateY(0%)' : 'translateY(-100%)';
  }
}
function getDisplayPosition({
  isFullScreen,
  position,
}: Props) {
  return isFullScreen
    ? {
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
    }
    : {
      bottom: position !== 'top' ? 0 : undefined,
      left: position !== 'right' ? 0 : undefined,
      right: position !== 'left' ? 0 : undefined,
      top: position !== 'bottom' ? 0 : undefined,
    };
}

const stopPropagation = (evt: React.MouseEvent): void => {
  evt.stopPropagation();
};

// Component Definition
const Container: FC<PropsWithChildren<Props>> = props => (
  <Box
    {...getDisplayPosition(props)}
    backgroundColor="card_background"
    className="drawer_container"
    display="flex"
    flexDirection="column"
    onClick={stopPropagation}
    overflowY="visible"
    padding={props.isPaddingDisabled ? undefined : 6}
    pointerEvents="all"
    position="fixed"
    transform={getTransform(props)}
    transition={`${props.transition}ms`}
    withBoxShadow
  >
    {props.children}
  </Box>
);

export default Container;
